import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { ArrowLeft, ChatCircleText } from "@phosphor-icons/react";
import ContactForm from "@/components/ContactForm";

// iter v29 r261 — Pagina contatti pubblica · sostituisce i mailto:
// nella landing/pricing (anti-scraping email). Il messaggio finisce nel
// DB MongoDB (collection contact_messages) e si legge dal pannello founder.
// NOTA: `Contatti.jsx` è il CRM contatti dell'agente loggato — non
// confondere.

export default function PublicContact() {
  const [params] = useSearchParams();
  const defaultSubject = params.get("argomento") || "generale";

  return (
    <div className="min-h-screen bg-[#FFFFFF]" data-testid="contatti-public-page">
      <header className="glass-header sticky top-0 z-30">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 sm:h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center" data-testid="brand-link-contatti-public">
            <img
              src="/logo/full-with-tagline.png?v=2"
              alt="Pronto · per agenti immobiliari"
              className="h-12 sm:h-14 w-auto select-none"
              draggable="false"
            />
          </Link>
          <Link
            to="/"
            className="text-sm text-[#6B6A65] hover:text-[#7C8B6E] flex items-center gap-1.5"
            data-testid="contatti-public-home-link"
          >
            <ArrowLeft size={14} /> Home
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 lg:px-10 py-12 lg:py-20">
        <div className="flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] text-[#7C8B6E] font-semibold mb-3">
          <ChatCircleText size={14} weight="fill" />
          Contattaci
        </div>
        <h1
          className="font-editorial text-4xl lg:text-5xl tracking-tight"
          data-testid="contatti-public-title"
        >
          Parliamone.
        </h1>
        <p className="mt-5 text-[17px] text-[#3F3D38] leading-relaxed max-w-2xl">
          Compila il form qui sotto e ti rispondiamo entro 24 ore lavorative,
          dal lunedì al venerdì. Per le domande più frequenti puoi prima dare
          un&apos;occhiata alla pagina{" "}
          <Link to="/supporto" className="underline text-[#7C8B6E] hover:text-[#1C1C1A]">
            Supporto
          </Link>
          : forse trovi già la risposta.
        </p>

        <div className="mt-10">
          <ContactForm defaultSubject={defaultSubject} hideTitle />
        </div>

        <div className="mt-16 pt-6 border-t border-[#E5E7E0]">
          <p className="text-xs text-[#6B6A65]">
            Pronto · per agenti immobiliari · prontoimmo.it
          </p>
          <div className="mt-4 flex flex-wrap gap-3 text-xs">
            <Link to="/privacy" className="text-[#7C8B6E] hover:underline">
              Informativa Privacy
            </Link>
            <span className="text-[#D5DAC9]">·</span>
            <Link to="/terms" className="text-[#7C8B6E] hover:underline">
              Termini e Condizioni
            </Link>
            <span className="text-[#D5DAC9]">·</span>
            <Link to="/pricing" className="text-[#7C8B6E] hover:underline">
              Piani e prezzi
            </Link>
            <span className="text-[#D5DAC9]">·</span>
            <Link to="/supporto" className="text-[#7C8B6E] hover:underline">
              Supporto e FAQ
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}
